export enum userLoginActiontype {
  LOGIN_USER = "login_user",
  LOGIN_USER_SUCCESS = "login_user_success",
  LOGIN_USER_FAILURE = "login_user_failure",
}
